var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('search-voucher-component',{attrs:{"routeToPostulantsDetails":'admin-postulants-payments-vouchers',"routeToParticipantsDetails":'admin-participants-payments-vouchers'}})}
var staticRenderFns = []

export { render, staticRenderFns }